module.exports = { apiServer: 'https://api.azure.intimex.hk', AdminServer: 'https://admin.azure.intimex.hk' };
